export default {
  default: () => import("/Users/alex_bozh/VsCode/nuxt/smaildell/layouts/default.vue")
}